<template>
  <span :class="'icon-'+ icon" />
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/fonts/kaledo-icons/style.css';
</style>



// WEBPACK FOOTER //
// src/components/CComponents/CIconFont.vue